module.exports = __webpack_public_path__ + "static/images/zbg.aa46f4c.png";